<template>
    <div class="sm:max-w-3xl mx-auto">
        <transition name="fade" mode="out-in">
            <div class="card mb-5" v-if="resource.ready">
                <div class="card-title flex justify-between" v-once>
                    <div v-if="editing">Клиент – {{ entry.full_name }}</div>
                    <div v-else>Создать клиента</div>
                    <div>
                        <a
                            v-if="editing && entry.amo_link"
                            :href="entry.amo_link"
                            target="_blank"
                            class="btn btn-pink"
                        >Открыть в amoCRM</a>
                    </div>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <text-field
                            class="w-1/2 px-2"
                            title="Имя"
                            v-model="entry.first_name"
                            :errors="errors.first_name"
                            required
                        />

                        <text-field
                            class="w-1/2 px-2"
                            title="Фамилия"
                            v-model="entry.last_name"
                            :errors="errors.last_name"
                            required
                        />
                    </div>

                    <div class="flex -mx-2">
                        <text-field
                            class="w-1/2 px-2"
                            title="Номер телефона"
                            v-model="entry.phone"
                            :errors="errors.phone"
                            required
                        />

                        <text-field
                            type="email"
                            class="w-1/2 px-2"
                            title="Email"
                            v-model="entry.email"
                            :errors="errors.email"
                            required
                        />
                    </div>

                    <div class="flex -mx-2" v-if="editing">
                        <text-field
                            class="w-1/2 px-2"
                            title="ID amoCRM"
                            v-model="entry.amo_id"
                            :errors="errors.amo_id"
                        />
                    </div>

                    <div class="flex -mx-2" v-if="editing">
                        <select-field
                            class="w-1/2 px-2"
                            title="Ответственный"
                            label="full_name"
                            valueName="id"
                            :clearable="true"
                            :options="selects.sellers"
                            v-model="entry.seller_id"
                            :errors="errors.seller_id"
                        />

                        <select-field
                            class="w-1/2 px-2"
                            title="Партнер"
                            label="full_name"
                            valueName="id"
                            :clearable="true"
                            :options="selects.partners"
                            v-model="entry.partner_id"
                            :errors="errors.partner_id"
                        />
                    </div>

                    <hr class="mb-3" />

                    <button class="btn btn-primary">Сохранить</button>

                    <button v-if="editing" @click.prevent="destroy" class="btn btn-danger">Удалить</button>
                </form>
            </div>
        </transition>
        <orders :customerId="entry.id" v-if="editing" />
    </div>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import Orders from "./orders";
import qs from "qs";

export default {
    extends: ResourceForm,

    components: {
        Orders
    },

    data() {
        return {
            resource: {
                name: "admin.customers",
                endpoint: "admin/customers"
            },

            selects: {
                ready: false,
                partners: [],
                sellers: []
            }
        };
    },

    methods: {
        async fetchSelects() {
            await axios
                .get("/admin/users/all", {
                    params: {
                        filters: {
                            role: "partner"
                        }
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params);
                    }
                })
                .then(response => {
                    this.selects.partners = response.data.data;
                });

            await axios
                .get("/admin/users/all", {
                    params: {
                        filters: {
                            amo: 1
                        }
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params);
                    }
                })
                .then(response => {
                    this.selects.sellers = response.data.data;
                });

            this.selects.ready = true;
        }
    },

    mounted() {
        this.fetchSelects();
    }
};
</script>